export default "__VITE_ASSET__BLop5EzB__"